export enum SapEnvironment {
  D = 'D',
  Q = 'Q',
  Z = 'Z',
  P = 'P',
}
